import { useAuth } from 'context';
import { isInactiveCustomerLocked } from 'utils/InactiveCustomerUtils';
import { useStore } from 'zustand-lib/storeGlobal';

// true when the logged-in customer is INACTIVE and HIDE_PRODUCT_INACTIVE_CUSTOMER is on:
// the customer is kept on /onboarding with a stripped-down header and no navbar/footer.
const useInactiveCustomerLock = () => {
  const { customerInfo } = useAuth();
  const appConfig = useStore((state) => state.appConfig);
  return isInactiveCustomerLocked(customerInfo, appConfig);
};

export default useInactiveCustomerLock;
